export function requestGlobalAssistantWarmUpOnce(input: {
  isDrawerOpen: boolean;
  hasRequested: boolean;
  markRequested: () => void;
  onWarmUpError?: (error: unknown) => void;
  onWarmUpResult?: (response: unknown) => void;
  requestWarmUp: () => Promise<unknown>;
}): boolean {
  if (!input.isDrawerOpen || input.hasRequested) {
    return false;
  }

  input.markRequested();
  void input
    .requestWarmUp()
    .then((response) => {
      input.onWarmUpResult?.(response);
    })
    .catch((error: unknown) => {
      input.onWarmUpError?.(error);
    });
  return true;
}
